<template>
  <div class="request-token-overall">
    <div class="container">
      <div class="request-token-contents">
        <div class="request-token-content-one">
          <h2 class="request-token-title centralize">Request New Token</h2>
          <form @submit="handleSubmit">
            <div
              class="request-token-formfield"
              v-bind:class="{ 'valid-error': emailIsInvalid }"
            >
              <div>
                <label for="Email">Email</label>
                <span class="error" v-if="emailIsInvalid"
                  >Invalid Email address</span
                >
              </div>
              <input
                type="email"
                v-model="email"
                v-on:change="validateEmail"
                name="email"
                placeholder="joe@example.com"
                required
              />
            </div>


            <div class="centralize">
              <button
                class="request-token-button centralize"
                v-on:click="loading = !loading"
                v-bind:disabled="disabled"
                v-bind:class="{
                    submit: true,
                    disabled: disabled,
                    loading: loading,
                  }"
                >
                <span class="buttonText">Request Token</span>
              </button>
            </div>
          </form>
          <div class="redirect-texts">
            <p>
              Don't Have an Account Yet?
              <router-link to="/signup" class="colored-text" exact
                >SignUp</router-link
              >
            </p>
            <p>
              <router-link class="colored-text" to="/login">
                Go Back to Login
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '../../vue.config';
export default {
  name: 'request-token',
  data() {
    return {
      email: '',
      disableButton: false,
      disabled: true,
      emailIsInvalid: false,
      loading: false
    };
  },
  methods: {
    validateEmail(e) {
      const emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (emailFormat.test(e.target.value) === false || e.target.value.trim() === '') {
        this.disabled = true;
        this.emailIsInvalid = true;

      } else {
        this.disabled = false;
        this.emailIsInvalid = false;
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.loading = true;
      if (!this.email) {
        this.$toastr.error('Invalid Email Address.', 'Error');
        this.loading = false;
      } else {
        axios
          .post(`${config.devServer.proxy}/user/request-token`, {
            email: this.email,
          })
          .then((res) => {
            this.loading = false;
            this.email = '';
            this.$toastr.success(res.data.message, 'Success');
          })
          .catch((err) => {
            this.loading = false;
            err.response
              ? this.$toastr.error(err.response.data.message)
              : this.$toastr.error('Connection not available', err.message);
          });
      }
    },
  },
};
</script>

<style scoped>
.request-token-overall {
  /* background: linear-gradient(to right, #297a91, #192851); */
  background: var(--white);
  color: var(--colorSecondary);
  width: 100%;
  vertical-align: middle;
  height: 100vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.request-token-contents {
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 235px 0; */
}
.colored-text {
  color: var(--colorSecondary);
  font-family: "Open-sans" sans-serif;
}
.request-token-content-one {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.redirect-texts {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.redirect-texts p {
  margin: 5px 10px;
}
.request-token-title {
  margin-top: 15px;
  font-size: 2.25rem;
  margin-bottom: 2rem;
}
.request-token-formfield {
  background-color: var(--white);
  margin-top: 15px;
  margin-bottom: 50px;
  color: var(--mildBlack);
  font-size: 1.125rem;
  border: 0;
  border-bottom: 0.0625rem solid #e5e5e5;
  width: 100%;
  padding-bottom: 0.75rem;
}
.centralize {
  text-align: center;
}
input {
  background: none;
  border: 0;
  outline: none;
  width: 100%;
  height: 100%;
  outline: none;
}
::placeholder {
  outline: none;
  background: none;
}
.error,
label {
  font-size: 12px;
  color: var(--mildBlack);
}
.error {
  float: right;
  color: tomato;
}
.valid-error {
  background-color: #ffcccb;
}
@keyframes buttonLoadingSpinner {
  from {
    transform: rotate(0turn);
  }
  to {
    transform: rotate(1turn);
  }
}
.loading::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 4px solid transparent;
  border-top-color: var(--white);
  border-right-color: var(--white);
  border-radius: 50%;
  animation: buttonLoadingSpinner 1s linear infinite;
}
.buttonText{
  transition: all 0.2s;
}
.loading .buttonText{
  visibility: hidden;
  opacity:0;
}
.request-token-button {
  background: var(--colorSecondary);
  position: relative;
  color: var(--white);
  font-size: 15px;
  border: none;
  text-transform: uppercase;
  outline: none;
  padding: 15px 25px;
  border-radius: 30px;
}
.disabled.submit {
  background:#a4ede7;
}
.redirect-texts {
  justify-content: space-between;
  margin-top: 50px;
}

/* Responsiveness */
@media (max-width: 990px) {
  /* .request-token-contents {
    padding: 170px 0;
  } */
  .request-token-contents {
    width: 100%;
  }
  .redirect-texts p {
    font-size: 12px;
  }
}
@media (max-width: 767px) {
  /* .request-token-contents {
    padding: 220px 0;
  } */
  /* .request-token-content-one {
    width: 80%;
  } */
  .divider {
    display: none;
  }
  .redirect-texts {
    display: block;
  }
  .redirect-texts p {
    margin: 5px 0;
    text-align: center;
  }
}
@media (max-width: 464px) {
  .request-token-content-one {
    width: 90%;
  }
}
</style>
